module.exports = __webpack_public_path__ + "img/cooperate8.a0c92573.png";